export default {
    BusinessPurchaseOrderList: {
        order: '采购单号',
        requisition: '采购申请单号',
        type: '采购类型',
        taxCode: '税号',
        status: '采购单状态',
        label: '采购单标签',
        code: 'SKU编码',
        Creation: '创建时间',
        delivery: '预计到货时间',
        Completion: '完成日期',
        Generation: '生成日期',
        View: '查看',
        production: '采购单生产',
        tolerance: '数据容错',
        over: '完成采购',
        Abandoned: '废弃',
        chineseAudit1: '中国一审',
        chineseAudit2: '中国二审',
        australianAudit: '澳洲审核',
        contract: '客户合同号',
        source: '来源',
        shippingCountry: '出运国家',

        table: {
            order: '采购单号',
            requisition: '采购申请单号',
            status: '采购单状态',
            label: '采购单标签',
            Buyer: '采购员',
            Creation: '创建时间',
            arrival: '预计到货时间',
            Completion: '完成日期',
            Generation: '生成日期',
        },
        dataForm: {
            Purchase: '采购数量',
            received: '实际入库数量',
            Difference: '差额',
            tolerant: '容错数量',
            fault: '数据容错',
            empty: '容错数量不能为空',
        }
    }
};
